import React from 'react';
import OrderListItem from './OrderListItem';

function OrdersList({ orders, onDriverAction, getOrderStatusColor, formatCurrency }) {
  return (
    <div className="orders-section">
      <h3 className="section-title">📦 Mis Pedidos</h3>
      {orders.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">📭</div>
          <p>No hay pedidos en este momento</p>
          <p className="empty-subtitle">Mantente disponible para recibir nuevos pedidos</p>
        </div>
      ) : (
        <div className="orders-list">
          {orders.map(order => (
            <OrderListItem
              key={order.id}
              order={order}
              onDriverAction={onDriverAction}
              getOrderStatusColor={getOrderStatusColor}
              formatCurrency={formatCurrency}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default OrdersList;
